
import Sidemenu from '../components/base/sidemenu';
import DeviceManagementRedesign from '../components/device/DeviceManagementRedesign';

export default function DevicePage() {
  return (
    <div className="flex device-management-layout">
      <Sidemenu />
      <main className="device-management-content">
        <DeviceManagementRedesign />
      </main>
    </div>
  );
}
